
import BaseFirebaseRepository from '../../../components/repository/BaseFirebaseRepository';
import {getAjaxError} from "../../../jsx/Helper/helper";

const instances = {}
const defaultInstanceKey = Math.random()
export default class MembershipFreeItemRepository extends BaseFirebaseRepository {
    // Indicate that this repository use API instead of Firebase
    isUseAPI = true

    /**
     * @param {*} app
     * @return {MembershipFreeItemRepository}
     */
    static getInstance(app) {
        if (app == null) {
            // By default, use instance created from main App
            app = MembershipFreeItemRepository.context || defaultInstanceKey
        }
        if (app != null && instances[app] == null) {
            // Create a new instance
            instances[app] = new MembershipFreeItemRepository(app)
        }
        return instances[app]
    }
    getRef = () => {
        return null
    }
    getSingleRef = () => {
        // This repository uses API to load instead of Firebase, so this
        // function is not called
        return null
    }
    getBaseObject = () => {
        return {}
    }
    getApiBaseUrl = (id) => {
        if (!id || id == 'all') {
            return `/merchant/api/membership/free_items`
        }
        else {
            return `/merchant/api/membership/free_items/%id%`.replace('%id%', id)
        }
    }
    getReloadEventKey = () => {
        return "membership_benefits_version.changed"
    }

    /**
     * Once we get the result from Firebase, will use this to preprocess the
     * data before pass assign the data to getBaseObject()
     */
     preprocessItem = (rawFirebaseData) => {
        return rawFirebaseData
    }

    /**
     * Parse raw API response before perform any logic
     * @returns {Object}
     */
    parseRawApiResponse = (rawResponse) => {
        if (rawResponse) {
            if (!Array.isArray(rawResponse)) {
                return [rawResponse]
            }
            else {
                return rawResponse
            }
        }
        return []
    }

    getClaimedItems = (membershipFreeItemIds) => {
        if (!Array.isArray(membershipFreeItemIds)) {
            membershipFreeItemIds = [membershipFreeItemIds]
        }
        return new Promise((resolve, reject) => {
            $.ajax({
                url : this.getApiBaseUrl(),
                data: {
                    membership_free_item_ids: membershipFreeItemIds,
                },
                success: res => {
                    resolve(res)
                }
            })
            .fail((xhr) => {
                const { errorCode, message, json } = getAjaxError(xhr)
                reject({ errorCode, message, json })
            })
        })
    }
}
